import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';

import { IRequest } from '../pages/hospital/Request/types';

export function useRequest(idRequest: number) {
    const currentInvestigationUuid = useSelector((state: any) => 
        state.investigations.currentInvestigation?.uuid
    );
    const hasInvestigationsData = useSelector((state: any) => 
        Boolean(state.investigations.data)
    );
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [request, setRequest] = useState<IRequest | null>(null);

    const fetchRequest = useCallback(async () => {
        const response = await axios(`${import.meta.env.VITE_APP_API_URL}/hospital/${currentInvestigationUuid}/request/${idRequest}`, { 
            headers: {"Authorization" : localStorage.getItem("jwt")} 
        }).catch(err => {
            console.log('Catch', err); 
            return err;
        });
        
        if(response.status === 200){
            setRequest(response.data.request);
        }
    }, [idRequest, currentInvestigationUuid]);

    useEffect(() => {
        if(hasInvestigationsData && currentInvestigationUuid){
            setLoadingRequest(true);
            fetchRequest().finally(() => setLoadingRequest(false));
        }
        
    }, [fetchRequest, hasInvestigationsData])

    // SHER-1062: re-fetch after an item change without raising loadingRequest. The page shows the
    // Loader while that flag is up, which would unmount the panel and the toast confirming the change.
    return { request, loadingRequest, reloadRequest: fetchRequest }
}
